/** The existing upstream rule pass must keep the configuration it started with. */
export function upstreamRules(rules) {
  return rules.filter(rule => rule.active === true &&
    ['zero-tolerance', 'accountability', 'mention'].includes(rule.type))
    .sort((a, b) => String(a.id).localeCompare(String(b.id)));
}

function canonical(value) {
  if (value instanceof Date) return value.getTime();
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === 'object') return Object.fromEntries(
    Object.keys(value).sort().map(key => [key, canonical(value[key])])
  );
  return value;
}

export function originalRuleConfiguration(rules, phasePolicy) {
  return { version: 1, rules: upstreamRules(rules), phasePolicy };
}

/** Legacy records have no snapshot; they retain their existing processing path. */
export function assertOriginalRuleConfiguration(saved, rules, phasePolicy) {
  if (saved == null) return;
  const current = originalRuleConfiguration(rules, phasePolicy);
  if (saved.version !== 1 || JSON.stringify(canonical(saved)) !== JSON.stringify(canonical(current))) {
    const error = new Error('Rules changed. This saved Mention needs review before retrying.');
    error.code = 'failed-precondition';
    error.ruleConfigurationChanged = true;
    throw error;
  }
}
